// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { COUNTRY } from '../../../common/constant'
import { post } from '../../api'

export const actionCountry = createAsyncThunk('appCountry/actionCountry', async (params, thunkAPI) => {
    return await post(COUNTRY, params, thunkAPI)
})

export const appCountrySlice = createSlice({
    name: 'appCountry',
    initialState: {
        //list
        loading: false,
        country: null
    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetCountryResponse: (state) => {
            state.country = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionCountry.pending, (state) => {
                state.loading = true
            })
            .addCase(actionCountry.fulfilled, (state, action) => {
                state.loading = false
                state.country = action.payload
            })
            .addCase(actionCountry.rejected, (state) => {
                state.loading = false
            })
    }
})
export const { resetCountryResponse } = appCountrySlice.actions

export default appCountrySlice.reducer